import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Accept, Cancel } from 'Common/Components/Button/styled';
import {
  selectCredentialsSelected, selectModalBulkUpdateValue
} from 'store/Credentials/selectors';
import { MODAL_MANAGE_BULK_UPDATE, MODAL_MANAGE_BULK_UPDATE_CONFIRMATION } from 'store/modals/modals';
import { closeModal, openModal } from 'store/modals/actions';
import { bulkUpdateCredentials, clearError } from 'store/Credentials/actions';
import { useIntl } from 'react-intl';
import useModalShortcuts from 'Hooks/useModalShortcuts';
import ButtonsContainer from './styled';

const SubmitButtons = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const cancelLabel = intl.formatMessage({ id: 'common.components.button.cancel' });
  const saveLabel = intl.formatMessage({ id: 'common.components.button.save' });

  const bulkUpdateValue = useSelector(selectModalBulkUpdateValue);
  const disabled = !bulkUpdateValue || bulkUpdateValue.length === 0;
  const credentialsSelected = useSelector(selectCredentialsSelected);
  const selectedCredentialsCount = credentialsSelected.length;

  const handleClose = () => {
    dispatch(closeModal(MODAL_MANAGE_BULK_UPDATE));
    dispatch(clearError());
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedCredentialsCount > 1) dispatch(openModal(MODAL_MANAGE_BULK_UPDATE_CONFIRMATION));
    else dispatch(bulkUpdateCredentials(bulkUpdateValue));
  };

  useModalShortcuts({ id: 'bulk-update-credentials', onSave: handleSubmit, onCancel: handleClose, canSave: !disabled, saveLabel });

  return (
    <ButtonsContainer>
      <Cancel onClick={ handleClose } children={ cancelLabel } />
      <Accept onClick={ handleSubmit } children={ saveLabel } disabled={ disabled } />
    </ButtonsContainer>

  );
};

export default SubmitButtons;
